/**
 * global constants
 */
window.CurrentUser = {
    userId: '',
    email: '',
    ethAddress: '',
    token: ''
};

window.Constants = {
    CURRENT_USER: "CurrentAdmin"
};